export default "__VITE_PUBLIC_ASSET__f0935eb0__"